import styled from 'styled-components';

export const PopularToolsList = styled.ul`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 16px;

  li {
    flex-basis: 33.33%;
    margin: 14px 0;
    @media (min-width: 720px) {
      cursor: default;
    }
  }
`;

export const ToolsRoundCorner = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 1px solid hsl(0deg, 0%, 0%, 20%);
  padding: 16px;
  margin: auto;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  .total_tools {
    font-size: 18px;
    font-weight: 500;
    color: hsl(0deg, 0%, 0%, 87%);
  }

  img {
    width: 100%;
    height: auto;
  }
`;

export const ToolsName = styled.p`
  font-size: 11px;
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  text-align: center;
  padding-top: 8px;
`;
